import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const READS = ["Pick", "Place"];
const FEEDS = [["Course", "/admission"], ["Prove", "/advanced"], ["Shortlist", "/shortlist"]];

// The reflective line on the full map: what Realisations reads and which stops it feeds.
export function RealisationsLine() {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-12" data-testid="journey-map-realisations-line">
      <div className="rounded-xl border-2 border-dashed border-[#A21CAF]/40 bg-white p-5 lg:p-6 flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-center gap-2 shrink-0">
          <Sparkles className="h-5 w-5 text-[#A21CAF]" aria-hidden="true" />
          <span className="font-editorial text-2xl text-stone-900">Realisations</span>
        </div>
        <p className="text-sm text-stone-600 leading-relaxed flex-1">
          A reflective line, not a stop you have to reach. It reads your{" "}
          {READS.map((r, i) => <strong key={r} className="text-stone-800">{r}{i === 0 ? " and " : ""}</strong>)} answers and your saved courses,
          and what it notices feeds into{" "}
          {FEEDS.map(([label, to], i) => (
            <span key={label}>
              <Link to={to} data-testid={`journey-map-realisations-feeds-${label.toLowerCase()}`} className="text-[#A21CAF] underline underline-offset-2">{label}</Link>
              {i < FEEDS.length - 2 ? ", " : i === FEEDS.length - 2 ? " and " : ""}
            </span>
          ))}
          . Nothing it suggests is saved to your profile until you confirm it.
        </p>
        <Link to="/realisations" data-testid="journey-map-realisations-open"
          className="shrink-0 inline-flex min-h-[44px] items-center rounded-md bg-[#A21CAF] px-4 text-sm font-medium text-white hover:bg-[#86198F] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A21CAF] focus-visible:ring-offset-2">
          Open Realisations
        </Link>
      </div>
    </section>
  );
}
